import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-iframe-club',
  templateUrl: './iframe-club.component.html',
  styleUrls: ['./iframe-club.component.scss']
})
export class IframeClubComponent implements OnInit {

  offers: FullOffer[];

  constructor(
    private route: ActivatedRoute,
    private offerService: OfferService,
    private router: Router,
    private imgOfferDefault: ImgOfferDefaultService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.getOfferWithTags();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getImgOffer(img: string): string {
    return !img.includes('data') ? `${environment.apiUrl}/images/${img}` : this.imgOfferDefault.imgDefault;
  }

  getIdOfferAdd(offer: string): string {
    return `add_${offer.toLowerCase().split(' ').join('_')}`;
    // return 'test'
  }

  getIdOffer(index: number): string {
    return `offer_${index}`;
  }

  openOfferInNewTab(offerKey: number) {
    const { structure, universe } = this.route.snapshot.queryParams;

    const queryParams = {
      offerKey,
      structure,
      universe
    };

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/home/offer`], {
        queryParams
      })
    );

    window.open(url, '_blank');
  }

  private getOfferWithTags(tagString: string = '', coordinates: string = '', universeChange?: number): void {
    this.offers = [];
    const structure = this.route.snapshot.queryParams.structure || '';
    const universe = universeChange ? universeChange : (this.route.snapshot.queryParams.universe || '');

    this.offerService.getOfferTag(tagString, coordinates, structure, universe).subscribe({
      next: offers => this.offers = offers
    });
  }

}
